import styled from 'styled-components'

import PhotosCarousel from 'src/comps/Molecules/PhotosCarousel'
import { updatedMedia } from 'client/styles'

interface Props {
  showCta: boolean
}

export const Content = styled.div`
  height: ${({ showCta }: Props) => (showCta ? 'calc(100% - 88px)' : '100%')};
  overflow-y: scroll;
`

export const ComposedPhotosCarousel = styled(PhotosCarousel)`
  user-select: none;
  ${updatedMedia.tablet} {
    height: calc(100% - 88px);
  }
`
